<template>
  <div class="div_title" >
    <span style="color: #ff7f50;">{{ $t('menu.summary') }}</span> 
    <span>
      <Button :label="$t('menu.search')" v-on:click="refresh" raised size="small" style="float:right;" ></Button>
      <select v-model="date" class="select-keyword" style="background-color:white;">  <!-- 카카오 ID로 검색 -->
        <option value = "r1">{{ $t('menu.month1') }}</option>
        <option value = "r2">{{ $t('menu.month3') }}</option>
        <option value = "r3">{{ $t('menu.month6') }}</option>
        <option value = "r4">{{ $t('menu.month12') }}</option>
      </select>
    </span>
  </div>
  <dashboard page="home" class="card main apple-card" :key='dashboardKey' @login="this.$emit('login')" />
  <div class="div_title" ><span style="color: #ff7f50;">{{ $t('menu.estimatedQuote') }}</span> </div>
  <estimate1 class="card main apple-card" id="estimate_section" />
  <div class="div_title"><span style="color: #ff7f50;">{{ $t('menu.cmplBuy') }}</span> </div>
  <div class="card main apple-card"><estimate2 /></div>
  <div class="div_title"><span style="color: #ff7f50;">{{ $t('menu.cmplDelivery') }} - <span style="font-weight: normal; font-size:11px;">{{ $t('sentence.dealedList') }}</span></span></div>
  <div class="card main apple-card"><estimate3 /></div>  
  <div class="div_title"><span style="color: #ff7f50;">{{ $t('menu.mustRead') }}</span></div>
  <faq id="faq_section" />
  <div class="div_title ">
    <span style="color: #ff7f50;">{{ $t('menu.review') }}</span>
    <span class="link" style="font-size: 12px;" @click="router('review')">{{ $t('menu.more') }}</span>
  </div>
  <ordercarousel id="ordercarousell_section" class="apple-card"/>
  <br>
  <div class="ad-container">
    <Adsense
      data-ad-client="ca-pub-6699354447815429" 
      data-ad-slot="8230887469"
      data-ad-format="horizontal"
      data-full-width-responsive="true">
    </Adsense>
  </div>
  <img src="./assets/logo_big.jpg" style="display: none;" alt="geek9.kr">
  <div class="flex justify-center" >
    <Dialog v-model:visible="NoticePopupVisible" modal :header="`${ t('menu.notify') }`" :style="{ width: '80%' }">
      <div class="flex flex-col gap-4">
        <label v-for="(notice, index) in noticeList" :key="index" >
          <h3 class="text-base font-semibold mt-0 mb-2">{{ index+1 }}. {{ notice.TITLE }}</h3>
          <Divider/>
          <p class="text-sm leading-relaxed mt-0 mb-0 text-surface-600 dark:text-surface-300" v-html="notice.CONTENT"/>
          <br>
        </label>
      </div>
      <template #footer>
        <Button @click="NoticePopupVisible = false">{{ $t('menu.confirm') }}</Button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import dashboard from './components/home/dashboard.vue'
import estimate1 from './components/home/estimate1.vue'
import estimate2 from './components/home/estimate2.vue'
import estimate3 from './components/home/estimate3.vue'
import ordercarousel from './components/home/ordercarousel.vue'
import faq from './components/home/faq.vue'
import ssr from './components/common/ssr'
import { inject, ref } from 'vue'
import router from './router'
import { useI18n } from 'vue-i18n'

export default {
  emits: ["setCookies", "setMenu", "login", "logout"],
  setup() {
    const setMeta = inject('setMeta')
    const NoticePopupVisible = ref(false)
    const { t } = useI18n()
    
    setMeta({
      title: 'GEEK9 - 한방에 직구하기',
      keywords: '직구,해외직구,구매대행,배송대행,배대지,해외운송,이사,geek9,3PL,풀필먼트',
      description: '해외직구/구매대행/배송대행/결제대행/해외운송/이사/3PL',
      'og:title': 'GEEK9 - 한방에 직구하기',
      'og:description': '해외직구/구매대행/배송대행/결제대행/해외운송/이사/3PL',
      'og:image': 'https://geek9.kr/img/favicon.png',
      'og:url': ssr.GEEK9_URL,
      'canonical': ssr.GEEK9_URL
    })

    const addJsonLd = () => {
      let flag = true
      document.querySelectorAll('script').forEach(el => {
        if (el.getAttribute('type') === 'application/ld+json' ) {
          flag = false
          return
        }
      })
      if(flag === true) {
        const script = document.createElement('script')
        script.setAttribute('type', 'application/ld+json')
        script.textContent = JSON.stringify(
          {
            "@context": "https://schema.org",
            "@graph": [
              ssr.getWebsite(ssr.GEEK9_URL, "GEEK9 - 한방에 직구하기", "GEEK9 - 해외기업물류/개인해외직구"),
              ssr.getOrganization(ssr.GEEK9_URL, "GEEK9"),
              ssr.getWebPage(ssr.GEEK9_URL, "GEEK9 - 한방에 직구하기", ssr.GEEK9_URL, "글로벌 물류대행 업체 GEEK9 - 구매대행/배송대행/결제대행/수출/수입/통관/3PL/풀필먼트"),
              {
                "@type": "BreadcrumbList",
                "name": "GEEK9 주요 서비스",
                "itemListElement": [{
                  "@type": "ListItem",
                  "name":"GEEK9 > 해외직구도우미",
                  "position": 1,
                  "item":{"@id":ssr.GEEK9_URL+"helper#webPage"} 
                },{
                  "@type": "ListItem",
                  "name":"GEEK9 > 해외중고샵",
                  "position": 2,
                  "item": {"@id":ssr.GEEK9_URL+"shop#webPage"} 
                },{
                  "@type": "ListItem",
                  "name":"GEEK9 > 문의",
                  "position": 3,
                  "item": {"@id":ssr.GEEK9_URL+"qna#webPage"}
                },{
                  "@type": "ListItem",
                  "name":"GEEK9 > 게시판",
                  "position": 4,
                  "item": {"@id":"https://contents.geek9.kr/#webPage"} 
                },{
                  "@type": "ListItem",
                  "name":"GEEK9 > 기업물류",
                  "position": 5,
                  "item": {"@id":ssr.GEEK9_URL+"biz#webPage"} 
                }]
              }
            ]
          }
        )
        document.head.appendChild(script)
      }
    }
    return {
      addJsonLd, t, NoticePopupVisible
    }
  },
  components: {
    dashboard, estimate1, estimate2, estimate3, faq, ordercarousel
  },
  mounted() {
    this.addJsonLd()
    let menuType = this.$route.params.type
    if(menuType !== undefined && menuType !== ''){
      const el = document.getElementById(menuType)
      el.scrollIntoView(el.scrollTop)
      el.setAttribute('class', 'card main blink')
      if(menuType === 'estimate_section') this.$emit("setMenu", {page: menuType})
    }
    this.api.setPage('home')
    console.log(this.api.getCookies('page'))
    this.emitter.on('homeReload', this.reload)
    this.getNotice()
    if(window.$cookies.get('login') === 'true') {
      if(!document.getElementById('user_name')) {
        const link = document.createElement('a')
        link.href = 'https://geek9.kr'
        document.body.appendChild(link)
        link.click()
      } else {
        document.getElementById('user_name').innerHTML = window.$cookies.get('nickname')
        document.getElementById('user_pic').src = window.$cookies.get('img')
      }
    }
    this.emitter.emit('refresh' + this.api.getCookies('page'), {range: this.date})

  },
  unmounted() {
    this.emitter.off('homeReload', this.reload)
  },
  data(){
    return{
      noticeList: [],
      date: 'r2',
      dashboardKey: 0
    }
  },
  methods : {
    async getNotice() {
      await this.api.axiosGql('SELECT_NOTICE', {type:'SELECT_NOTICE', noticeType: 'popup', useYn:true, page:1})
      .then( async (res) => {
        let json = res.data
        this.noticeList = json
        if(this.noticeList.length !== 0) this.NoticePopupVisible = true
      })
    },
    router(page) {
      router.push({name:page})
    },
    reload(flag) {
      if(this.noticeList.length === 0) this.getNotice()
      if(flag === 'dashboard') {
        this.dashboardKey += 1
      }
      this.refresh()
    },
    async refresh() {
      this.emitter.emit('refresh' + this.api.getCookies('page'), {range: this.date})
    },
  }
}
</script>

<style>
* {
  scroll-behavior: smooth;
}
@keyframes blink-effect {
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink-effect 1s step-end 4;
}

</style>
